(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/tournament-registration-form/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/tournament-registration-form/assets/javascripts/utils.js');
"use strict";

const log = new svs.core.log.Logger('svs.poker_react.components.tournamentRegistrationForm');
const svsFetch = svs.core.svsFetch.create();
const useNewBookingApi = svs.core.detect.feature('ft-iam-no-iframe');
const _svs$poker_react$comp = svs.poker_react.components.tournamentRegistrationForm.constants,
  GameTypes = _svs$poker_react$comp.GameTypes,
  Blinds = _svs$poker_react$comp.Blinds,
  Stack = _svs$poker_react$comp.Stack,
  StackOld = _svs$poker_react$comp.StackOld,
  Buyin = _svs$poker_react$comp.Buyin,
  BuyinOld = _svs$poker_react$comp.BuyinOld,
  LateRegistration = _svs$poker_react$comp.LateRegistration,
  TimeBank = _svs$poker_react$comp.TimeBank,
  ReEntry = _svs$poker_react$comp.ReEntry,
  TableSize = _svs$poker_react$comp.TableSize;
const showModal = function (title, icon, text) {
  let type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DEFAULT';
  const dialogOptions = {
    branding: svs.components.dialog.branding.SPORT,
    title,
    icon,
    area: svs.components.dialog.area.POPUP,
    type: svs.components.dialog.type[type],
    product: 'Poker',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  };
  const dialog = new svs.components.dialog.Confirm(dialogOptions);
  svs.components.dialog.api.add(dialog);
};
const bookTournament = async (data, onSuccess, onError) => {
  try {
    const response = await svsFetch('/v2/tournament/bookings', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error("Response: ".concat(response.status));
    }
    const result = await response.json();
    if (result.success) {
      showModal('Turneringen är beställd', 'information', 'Vi återkommer med en bekräftelse.');
      onSuccess();
    } else {
      throw new Error('Turneringen är inte beställd!');
    }
  } catch (e) {
    showModal('Något gick fel vid registreringen', 'help-2', 'Försök igen och kontakta vår kundservice om felet kvarstår.', 'ERROR');
    log.error('Error registering poker tournament.', e);
    onError();
  }
};
const handleSubmit = (formData, onSuccess, onError) => {
  const data = {
    blinds: Blinds.find(blind => blind.id === formData.blinds).title,
    buyin: useNewBookingApi ? Buyin.find(buyin => buyin.id === formData.buyin).title : BuyinOld.find(buyin => buyin.id === formData.buyin).title,
    date: formData.date,
    email: formData.email,
    stack: useNewBookingApi ? Stack.find(stack => stack.id === formData.stack).title : StackOld.find(stack => stack.id === formData.stack).title,
    time: formData.time,
    'tournament-password': formData.password,
    'player-name': formData.name,
    'tournament-name': "(P)".concat(formData.tournamentName),
    timebank: TimeBank.find(timeBank => timeBank.id === formData.timeBank).title,
    'late-registration': LateRegistration.find(lateRegistration => lateRegistration.id === formData.lateRegistration).title,
    type: GameTypes.find(gameType => gameType.id === formData.gameType).title,
    're-entry': ReEntry.find(reEntry => reEntry.id === formData.reEntry).title,
    tablesize: TableSize.find(tableSize => tableSize.id === formData.tableSize).title
  };
  if (useNewBookingApi) {
    bookTournament(data, onSuccess, onError);
  } else {
    const options = {
      method: 'PUT',
      path: '/supportive/1/pokerbookingmessages',
      data
    };
    svs.core.jupiter.call(options, () => {
      showModal('Turneringen är beställd', 'information', 'Vi återkommer med en bekräftelse.');
      onSuccess();
    }, error => {
      showModal('Något gick fel vid registreringen', 'help-2', 'Försök igen och kontakta vår kundservice om felet kvarstår.', 'ERROR');
      log.error('Error registering poker tournament.', error);
      onError();
    });
  }
};
setGlobal('svs.poker_react.components.tournamentRegistrationForm.utils', {
  handleSubmit
});

 })(window);